<script lang="ts">
    import {dyData, modal} from 'general/store';
    import {TEMPLATE} from 'general/constants';

    import Description from 'general/components/description/Description.svelte';
    import RecommendationsCarousel from 'desktop/components/recommendationsCarousel/RecommendationsCarousel.svelte';
    import type {ProductRecommendationType} from 'types/dy';

    export let recommendations: ProductRecommendationType[];
    modal.setCurrentTemplateType($dyData.template);
</script>

<div class="main" style="margin-top: {$dyData.side.main?.marginTop || 0}">
    <Description
        template={TEMPLATE.SQUARE_EXIT_RECOMMENDATIONS}
        value={$dyData.description?.main}
    />
    <RecommendationsCarousel {recommendations} />
</div>
